/**
 * @module router
 * @category Gerenciador de rotas
 * @summary Módulo do gerenciador de rotas do sistema.
 *
 * @description
 * Expõe uma instância de {@link external:VueRouter VueRouter} contendo as
 * configurações de rota ({@link external:RouteConfig RouteConfig}) do sistema.
 *
 * @requires module:constants.MODULOS_ROUTE
 */
import Vue from "vue";
import VueRouter from "vue-router";

import { MODULOS_ROUTE } from "../constants";

import ControleAcesso from "../views/ControleAcesso.vue";
import Início from "../views/Home.vue";
import Login from "../views/Login.vue";
import MeusDados from "../views/MeusDados.vue";
//import Modulos from "../views/Modulos.vue";

Vue.use(VueRouter);

/**
 * _Array_ de configurações de rotas do container do sistema.
 * @type {Array<external:RouteConfig>}
 * @readonly
 */
const routes = [
  {
    path: "",
    name: "containerEmpty",
    component: Início
  },
  {
    path: "/home",
    name: "containerHome",
    component: Início
  },
  {
    path: MODULOS_ROUTE,
    name: "containerModulos",
    component: Início
  },
  /*{
    path: MODULOS_ROUTE,
    name: "containerModulos",
    component: Modulos,
    meta: {
      title: "Módulos"
    }
  },*/
  {
    path: "/meus-dados",
    name: "containerMeusDados",
    component: MeusDados,
    meta: {
      title: "Meus Dados"
    }
  },
  {
    path: "/controle-acesso",
    name: "containerControleAcesso",
    component: ControleAcesso,
    meta: {
      title: "Controle de Acesso",
      permissions: ["ADMIN"]
    }
  },
  {
    path: "/login",
    name: "containerLogin",
    component: Login,
    meta: {
      title: "Login"
    }
  }
];

/**
 * Estrutura com as opções utilizadas pelo gerenciador de rotas do sistema
 * ({@link external:VueRouter VueRouter}).
 * @type {object}
 * @property {string} mode - Modo de utilização do histórico do browser. Valor
 * definido: "history".
 * @property {Array<external:RouteConfig>} routes - {@link module:router~routes}
 * @readonly
 */
const routerOptions = {
  mode: "history",
  routes
};

export default new VueRouter(routerOptions);
